/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentInferencerPolymorphic } from './VoiceAgentInferencerPolymorphic';
import {
  VoiceAgentInferencerPolymorphicFromJSON,
  VoiceAgentInferencerPolymorphicFromJSONTyped,
  VoiceAgentInferencerPolymorphicToJSON,
} from './VoiceAgentInferencerPolymorphic';

/**
 *
 * @export
 * @interface PaginatedVoiceAgentInferencerPolymorphicList
 */
export interface PaginatedVoiceAgentInferencerPolymorphicList {
  /**
   *
   * @type {number}
   * @memberof PaginatedVoiceAgentInferencerPolymorphicList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedVoiceAgentInferencerPolymorphicList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedVoiceAgentInferencerPolymorphicList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<VoiceAgentInferencerPolymorphic>}
   * @memberof PaginatedVoiceAgentInferencerPolymorphicList
   */
  results: Array<VoiceAgentInferencerPolymorphic>;
}

/**
 * Check if a given object implements the PaginatedVoiceAgentInferencerPolymorphicList interface.
 */
export function instanceOfPaginatedVoiceAgentInferencerPolymorphicList(
  value: object,
): value is PaginatedVoiceAgentInferencerPolymorphicList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedVoiceAgentInferencerPolymorphicListFromJSON(
  json: any,
): PaginatedVoiceAgentInferencerPolymorphicList {
  return PaginatedVoiceAgentInferencerPolymorphicListFromJSONTyped(json, false);
}

export function PaginatedVoiceAgentInferencerPolymorphicListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedVoiceAgentInferencerPolymorphicList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(VoiceAgentInferencerPolymorphicFromJSON),
  };
}

export function PaginatedVoiceAgentInferencerPolymorphicListToJSON(
  value?: PaginatedVoiceAgentInferencerPolymorphicList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(VoiceAgentInferencerPolymorphicToJSON),
  };
}
